import { HeaderState } from '../header/headerState'
import { isGoogleCookieSet, isTranslationBannerCookieSet } from './translateUtils'

export type TranslateState = {
  isTranslateModalOpen: boolean
  isTranslateBannerVisible: boolean
}

export const translateStateUpdaters = {
  toggleTranslateModal:
    (toggle: boolean) =>
    (s: HeaderState): HeaderState => ({
      ...s,
      translateState: { ...s.translateState, isTranslateModalOpen: toggle },
    }),
  closeTranslateBanner:
    () =>
    (s: HeaderState): HeaderState => ({
      ...s,
      translateState: { ...s.translateState, isTranslateBannerVisible: false },
    }),
  updateTranslateStateOnLanguageSelect:
    () =>
    (s: HeaderState): HeaderState => ({
      ...s,
      translateState: {
        isTranslateModalOpen: false,
        isTranslateBannerVisible: true,
      },
    }),
}

const initialTranslateBannerVisiblity = () => {
  return isTranslationBannerCookieSet() && isGoogleCookieSet()
}

export const initialTranslateState = {
  isTranslateModalOpen: false,
  isTranslateBannerVisible: initialTranslateBannerVisiblity(),
}
